import redirectInterceptor from "@/interceptors/redirect_interceptor";
import HttpError from "../http_error";

export class KdiagramService {
  constructor(
    baseUrl,
    mapKdiagramCalculationResultDataFromJson,
    mapKdiagramCalculationDataToJson,
    mapKDiagramStaticDataFromJson,
    mapSeaTrialsDataFromJson
  ) {
    this.baseUrl = baseUrl;
    this.mapKdiagramCalculationResultDataFromJson = mapKdiagramCalculationResultDataFromJson;
    this.mapKdiagramCalculationDataToJson = mapKdiagramCalculationDataToJson;
    this.mapKDiagramStaticDataFromJson = mapKDiagramStaticDataFromJson;
    this.mapSeaTrialsDataFromJson = mapSeaTrialsDataFromJson;
  }

  // router kdname1
  async calculateByPreset(accessToken, vesselName, profileId) {
    const requestParams = {
      method: "GET",
      url: `${this.baseUrl}/vesselperformance/vessel/${vesselName}/kdiagramdynamicMultiKD/${profileId}`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "Authorization": `${accessToken}`,
      },
    };

    try {
      const response = await redirectInterceptor.request(requestParams);
      if (response.data.success) {
        const resp = JSON.parse(response.data.data.replace(/'/g, "\""));
        resp.dates = response.data.dates;
        resp.FDMDataClength = response.data.FDMDataClength;
        return this.mapKdiagramCalculationResultDataFromJson(resp);

      } else {
        throw new HttpError(response.data.msg);
      }
    } catch (error) {
      throw error;
    }
  }

  async calculate(accessToken, vesselName, data) {
    const requestParams = {
      method: "POST",
      url: `${this.baseUrl}/vesselperformance/vessel/${vesselName}/kdiagraminputMultiKD`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "Authorization": `${accessToken}`,
      },
      data: this.mapKdiagramCalculationDataToJson(data)
    };

    try {
      const response = await redirectInterceptor.request(requestParams);
      if (response.data.success) {
        const resp = JSON.parse(response.data.data.replace(/'/g, "\""));
        resp.dates = response.data.dates;
        resp.FDMDataClength = response.data.FDMDataClength;
        return this.mapKdiagramCalculationResultDataFromJson(resp);

      } else {
        throw new HttpError(response.data.msg);
      }
    } catch (error) {
      throw error;
    }
  }

  async fetchKDiagramSeaTrials(accessToken, vesselName) {
    const requestParams = {
      method: "GET",
      url: `${this.baseUrl}/kdiagram/vessel/${vesselName}/sea_trials`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "Authorization": `${accessToken}`,
      },
    };

    try {
      const response = await redirectInterceptor.request(requestParams);
      return this.mapSeaTrialsDataFromJson(response.data);
    } catch (error) {
      throw error;
    }
  }

  async fetchKDiagramStaticData(accessToken, vesselName) {
    const requestParams = {
      method: "GET",
      url: `${this.baseUrl}/vesselperformance/vessel/${vesselName}/kdiagramstatic`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "Authorization": `${accessToken}`,
      },
    };

    try {
      const response = await redirectInterceptor.request(requestParams);
      return this.mapKDiagramStaticDataFromJson(response.data.data);
    } catch (error) {
      throw error;
    }
  }
  // KdiagramService
  async fetchLatestFouling(accessToken, vesselName) {

    const requestParams = {
      method: "GET",
      url: `${this.baseUrl}/vesselperformance/vessel/${vesselName}/latest-fouling`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "Authorization": `${accessToken}`,
      },
    };

    try {
      const response = await redirectInterceptor.request(requestParams);

      if (response.data.success) {

        return response.data.data.fouling; // number or null
      } else {

        throw new HttpError(response.data.msg);
      }
    } catch (error) {

      throw error;
    }
  }

}
